import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { QueryKeys } from "../queryKeys";

export type AnnulmentCodeRequest = {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  status?: string;
};

async function getAnnulmentCodeList(data: AnnulmentCodeRequest): Promise<any> {
  try {
    return (await axiosInstance.post("/AnnulmentCode/List", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetAnnulmentCodeList({
  page = 0,
  size = 15,
  orderByDesc = true,
  orderBy = "CreateDate",
  status = "ACTIVE"
}: AnnulmentCodeRequest) {
  const data = {
    page,
    size,
    orderByDesc,
    orderBy,
    status
  };

  return useQuery(
    [QueryKeys.GetAnnulmentCodeList, data], 
    () => getAnnulmentCodeList(data)
  );
}
